<template><svg xmlns="http://www.w3.org/2000/svg" width="14.216" height="14" viewBox="0 0 14.216 14">
    <g transform="translate(0.108)" fill="none">
        <rect width="14" height="14"/>
        <g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5">
            <path d="M223.167,5682.871h2.473a.412.412,0,0,0,.412-.412v-2.714a.412.412,0,0,0-.12-.291l-.582-.583a.411.411,0,0,0-.291-.121h-1.891a.412.412,0,0,0-.412.412v3.3a.412.412,0,0,0,.412.412Z"
                  transform="translate(-212.694 -5669.622)"/>
            <path d="M223.167,5669.372h2.473a.412.412,0,0,0,.412-.411v-2.715a.412.412,0,0,0-.12-.291l-.582-.583a.413.413,0,0,0-.291-.121h-1.891a.412.412,0,0,0-.412.412v3.3A.412.412,0,0,0,223.167,5669.372Z"
                  transform="translate(-212.694 -5663.54)"/>
            <path d="M209.255,5663.75v.824" transform="translate(-208.613 -5662.864)"/>
            <path d="M209.255,5668.25v1.648" transform="translate(-208.613 -5664.892)"/>
            <path d="M209.255,5674.25v1.648" transform="translate(-208.613 -5667.594)"/>
            <path d="M209.255,5680.25v.824a.824.824,0,0,0,.824.824h.824"
                  transform="translate(-208.613 -5670.297)"/>
            <path d="M215.255,5683.25H216.9" transform="translate(-211.105 -5671.648)"/>
            <path d="M221.255,5683.25h.824" transform="translate(-213.655 -5671.648)"/>
            <path d="M215.255,5669.75H216.9" transform="translate(-211.105 -5665.567)"/>
            <path d="M221.255,5669.75h.824" transform="translate(-213.655 -5665.567)"/>
        </g>
    </g>
</svg>
</template>